// Handles the mobile "more" (...) button in the mobile header.
// It toggles the topbar (user bar with profile / sign out) on small screens.
// The theme's KTToggle (KTLayout.initHeader) binds the button by id only once on
// document ready, so the button is dead after the header is re-mounted by an
// in-app navigation (e.g. right after login). The button has no id on purpose,
// so this mixin is its only handler.
const BODY_CLASS = 'kt-header__topbar--mobile-on'

export default {
    data() {
        return {
            is_topbar_open: false,
        }
    },
    watch: {
        $route() {
            this.closeMobileTopbar()
        },
    },
    methods: {
        toggleMobileTopbar() {
            this.is_topbar_open ? this.closeMobileTopbar() : this.openMobileTopbar()
        },
        openMobileTopbar() {
            document.body.classList.add(BODY_CLASS)
            this.is_topbar_open = true
        },
        closeMobileTopbar() {
            document.body.classList.remove(BODY_CLASS)
            this.is_topbar_open = false
        },
    },
    beforeDestroy() {
        this.closeMobileTopbar()
    },
}
